import type { EnergyInputs } from "./types";

export const defaultEnergyInputs: EnergyInputs = {
  impulseEnergy: 260.5,
  weldLength: 13,
  power: 15.867,
  travelSpeed: 46.7
};
